export default function(element, eventName, options = {}) {
  // eslint-disable-next-line no-undef
  let event = new CustomEvent(eventName, options);
  element.dispatchEvent(event);
}
